/**
 * internal dependencies
 */
import { IPostVehiclePin, IPostPinPoolResponse } from "../models/cardgroup.interface";
import PostToApi from './route-helpers/api-post';

/**
 * Posts new Pin Pool data to AWS
 * 
 * @param {IPostVehiclePin} pinPool the pin pool data
 * 
 * @returns {IPostPinPool} the api response | error
 */
const PostVehiclePin = async (pinPool: IPostVehiclePin): Promise<IPostPinPoolResponse> => {
  const endpoint = `/card-group/${pinPool.cardGroupId}/vehicle-pin`;
  const errorMessage = 'Error updating vehicle pin';

  return PostToApi(endpoint, pinPool, errorMessage);
}

export default PostVehiclePin;